jQuery(document).ready(function($) {
"use strict";
$('#test_cust').owlCarousel( {
		loop: true,
		center: true,
		items: 1,
		margin: 30,
		autoplay: true,
		dots:true,
    nav:true,
  autoHeight:true,
		autoplayTimeout: 5000,
		smartSpeed: 450,
  	navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
		responsive: {
			0: {
				items: 1
			},
			768: {
				items: 1
			},
			1170: {
				items: 1
			}
		}
	});
});